import React from 'react';
import ConfirmationDF from '../components/SimulatorsComponents/DefualtSimulators/ConfirmationDF';
import { Thanks_for_your_help } from '../utils/DictionaryManagementUtils';

//= ========================================================================
const Sim_B10_SendMoneyConfirmation = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs,
}) => (
  <ConfirmationDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    simPlatform={simPlatform}
    stringButtom={Thanks_for_your_help}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_B10_SendMoneyConfirmation;
